import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { AiTextArea } from "../../../../components/Form/AiTextArea";
import Input from "../../../../components/Form/Input/input";
import Label from "../../../../components/Form/Label";
import { Form, FormGroup } from "../../../../components/Form/styles";
import { ImageField } from "../../../../components/ImageField";
import { Box } from "../../../../components/Layout";
import SaveBar from "../../../../components/SaveBar";
import { SubHeader } from "../../../../components/SubHeader";
import { CropProps } from "../../../../components/UploadImageInput";
import { useSite } from "../../../../contexts/Site";
import { WelcomeSection } from "../../../../model/site";
import { sanitizeUrl } from "../../../../utils/url"; //TODO
import { useSection } from "../../hooks/Section";
import { Container } from "./styles";

const buttonTitleMaxLength = 24;

const avatarCropOptions: CropProps = {
  slice: {
    aspect: 1,
  },
  size: {
    width: 400,
    height: 400,
  },
  cropShape: "round",
};

const WelcomePage = () => {
  const { t } = useTranslation();
  const { site } = useSite();

  const setDefaultValues = useCallback(
    (newly: boolean, section: WelcomeSection) => {
      if (newly) {
        section.exibitionName = site.title;
      }
      return section;
    },
    [site]
  );

  const { section, setSection, saveSection, hasUnsavedChanges } = useSection("welcome", setDefaultValues);

  const isSaveDisabled = !!section.buttonTitle && !section.buttonLink;

  const saveHandler = () => {
    saveSection({
      ...section,
      buttonLink: sanitizeUrl(section.buttonLink),
    });
  };

  return (
    <Container>
      <SubHeader
        title={t("pages.editor.welcome.header.title")}
        crumbs={[{ label: t("pages.editor.preview.footer.actions.sections"), to: "/editor/sections" }]}
        hasUnsavedChanges={hasUnsavedChanges}
      />
      <Form>
        <Box>
          <ImageField
            shape="round"
            crop={avatarCropOptions}
            title={t("pages.editor.welcome.form.addImage.buttonLabel")}
            hint={t("pages.editor.welcome.form.addImage.hint")}
            image={section.logo}
            onChange={logo => setSection({ ...section, logo })}
          />
        </Box>
        <Box borderBottom className="npt">
          <FormGroup>
            <Input
              id="buttonTitle"
              type="text"
              value={section.exibitionName}
              onChange={e =>
                setSection({
                  ...section,
                  exibitionName: e.target.value,
                })
              }
              maxLength={buttonTitleMaxLength}
              label={t("pages.editor.welcome.form.exibitionName")}
            />
          </FormGroup>
        </Box>
        <Box borderBottom>
          <FormGroup>
            <AiTextArea
              id="featuredTitle"
              name="featuredTitle"
              autoComplete="off"
              rows={5}
              value={section.featuredTitle}
              onChange={featuredTitle => setSection({ ...section, featuredTitle })}
              aiField="welcome.featuredTitle"
            />
            <Label htmlFor="featuredTitle" text={t("pages.editor.welcome.form.featuredTitle")} />
          </FormGroup>
          <FormGroup>
            <AiTextArea
              id="supportingText"
              name="supportingText"
              autoComplete="off"
              rows={5}
              value={section.supportingText}
              onChange={supportingText => setSection({ ...section, supportingText })}
              aiField="welcome.supportingText"
            />
            <Label htmlFor="supportingText" text={t("pages.editor.welcome.form.supportingText")} />
          </FormGroup>
        </Box>
        <Box>
          <FormGroup>
            <Input
              id="buttonTitle"
              type="text"
              value={section.buttonTitle}
              onChange={e =>
                setSection({
                  ...section,
                  buttonTitle: e.target.value,
                })
              }
              maxLength={buttonTitleMaxLength}
              label={t("pages.editor.welcome.form.buttonTitle")}
            />
          </FormGroup>
          <FormGroup>
            <Input
              autoCapitalize="none"
              id="buttonLink"
              type="text"
              value={section.buttonLink}
              required={!!section.buttonTitle?.length}
              onChange={e =>
                setSection({
                  ...section,
                  buttonLink: e.target.value,
                })
              }
              label={t("pages.editor.welcome.form.buttonLink")}
            />
          </FormGroup>
        </Box>
        <SaveBar onSave={saveHandler} disabled={isSaveDisabled} hasUnsavedChanges={hasUnsavedChanges} />
      </Form>
    </Container>
  );
};

export default WelcomePage;
